module.exports = __webpack_public_path__ + "static/media/html.a17e9a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/html.png
// module id = 115
// module chunks = 0